//========================
// printCode 入力の共通ハンドラ（#EasyCal スコープ）
//========================
(function($){
  'use strict';

  var SCOPE = '#EasyCal';

  function getPrintCode() {
    var $root = $(SCOPE);
    if (!$root.length) return '';
    var $radios = $root.find('input[type=radio][name=printCode]');
    if ($radios.length) {
      var v = $radios.filter(':checked').val();
      return (typeof v !== 'undefined' && v !== null) ? String(v) : '';
    }
    var $hidden = $root.find('input[type=hidden][name=printCode]');
    return $hidden.length ? String($hidden.val() || '') : '';
  }

  function setPrintCode(value) {
    var $root = $(SCOPE);
    if (!$root.length) return;
    var v = String(value || '');

    var $radios = $root.find('input[type=radio][name=printCode]');
    var $hidden = $root.find('input[type=hidden][name=printCode]');

    if ($radios.length) {
      // セレクタ直埋めはやめ、filterで一致判定（安全）
      var $t = $radios.filter(function(){ return String($(this).val()) === v; });

      // UIリセット
      $radios.parents('li').removeClass('Active');
      $root.find('div.MediaMoreInfo').hide();

      if ($t.length) {
        $t.prop('checked', true).parents('li').addClass('Active');
        $t.next().next().show();
        $t.trigger('change'); // 依存処理があれば拾う
      }
      // hidden があれば同値で同期（混在安定化）
      if ($hidden.length) $hidden.val(v);
      return;
    }

    // Radio が無い（hidden固定）
    if ($hidden.length) $hidden.val(v);
  }

  function reflectMediaSelection() {
    var $root = $(SCOPE);
    if (!$root.length) return;
    var $radios = $root.find('input[type=radio][name=printCode]');
    if (!$radios.length) return;

    $radios.parents('li').removeClass('Active');
    var $c = $radios.filter(':checked');
    if ($c.length) {
      $c.parents('li').addClass('Active');
      $c.next().next().show();
      // hidden があれば選択値で同期
      var $hidden = $root.find('input[type=hidden][name=printCode]');
      if ($hidden.length) $hidden.val(String($c.val() || ''));
    }
  }

  //========================
  // 初期表示時の選択表示（Radioがある場合のみ）
  //========================
  reflectMediaSelection();

  // メディア選択（Radio時）※#EasyCal 内に限定
  $(document).on('change', SCOPE + ' input[type=radio][name=printCode]', function () {
    var $root = $(SCOPE);
    var $radios = $root.find('input[type=radio][name=printCode]');
    $radios.parents('li').removeClass('Active');
    $(this).parents('li').addClass('Active');
    $(this).next().next().show();

    // hidden 同期
    var $hidden = $root.find('input[type=hidden][name=printCode]');
    if ($hidden.length) $hidden.val(String($(this).val() || ''));
    return false;
  });

  // よくあるサイズの追加（data-* は小文字属性に統一）
  $(document).on('click', 'a.addSize', function (e) {
    e.preventDefault();
    var thiswidth = $(this).attr('data-width');
    var thisheight = $(this).attr('data-height');
    $('input[name=width]').val(thiswidth);
    $('input[name=height]').val(thisheight);
  });

  // サイズ入力のバリデーション（小数切捨て）
  $(document).on('change', 'input.SizeInput', function () {
    var thisSize = $(this).val();
    $(this).val(Math.floor(thisSize || 0));
  });

  // 入力内容をクリアする
  $(document).on('click', 'a.clearInput', function (event) {
    event.preventDefault();

    // 画面内スクロール（先に視線をフォームへ）
    smoothScrollTo($('#SizeInputSpot'), 800, -20);

    // 入力欄は一旦クリア（見た目上すぐ反映）
    $('input[name=width]').val('');
    $('input[name=height]').val('');

    // 非同期差し替え：URLを「?」に戻して main を再描画
    var baseURL = location.pathname + '?'; // ★ここがポイント
    var targetTags = ['main'];

    startReloadCotent();
    var dfd = reloadCotent(baseURL, targetTags, 1); // replaceState で ? に書き換え
    dfd.done(function () {
      if (typeof thisPageReloadContent === 'function') thisPageReloadContent();

      // 念のため、差し替え後にもフォーム位置へ寄せる
      smoothScrollTo($('#SizeInputSpot'), 600, -20);
    });
  });

  // 「フォームに戻る」
  $(document).on('click', '.EasyCalBack', function (e) {
    e.preventDefault();
    smoothScrollTo($('#EasyCal'), 800);
  });

  // モーダルから面付け位置へ（超シンプル版）
  $(document).on('click', '.moveToTrimFromModal', function (e) {
    e.preventDefault();

    var $modal = $(this).closest('.remodal');
    if (!$modal.length) return;

    // 閉じ終わったらスクロール
    $(document).one('closed', '.remodal', function () {
      var $t = $('#trim_position');
      if ($t.length) {
        var offset = -20 - ($('#CL-MainNavi.NaviFixed').outerHeight() || 0);
        $('html, body').animate({
          scrollTop: $t.offset().top + offset
        }, 600, 'swing');
      }
    });

    $modal.remodal().close();
  });

  // 価格表ラミタブの切替
  $('div.tab-content').hide();
  $('div.tab-active').show();
  $(document).on('change', 'input.switchPriceList', function () {
    $(this).parents('ul').children('li').removeClass('active');
    $(this).parents('li').addClass('active');
    var group = $(this).attr('name');
    var lami = $(this).val();
    $('div[data-ContentGroup=' + group + ']').hide();
    $('div[data-ContentGroup=' + group + '][data-LamiType=' + lami + ']').show();
  });

  // 「計算する」ボタン
  $(document).on('click', 'input[name=calBtn]', function (e) {
    e.preventDefault();
    var width = $('input[name=width]').val();
    var height = $('input[name=height]').val();
    var printCode = getPrintCode();
    EasyCalAction(printCode, width, height);
    return false;
  });

  // 価格例リンク（data-printcode 厳守）
  $(document).on('click', 'a.calBtn', function (e) {
    e.preventDefault();
    var printCode = $(this).data('printcode'); // ★data-printcode に統一
    var width = $(this).attr('data-width');
    var height = $(this).attr('data-height');
    EasyCalAction(printCode, width, height);
    return false;
  });

  // 素材固定の「計算する」（data-printcode 厳守）
  $(document).on('click', 'input[name=TargetMediaInputBtn]', function (e) {
    e.preventDefault();
    var printCode = $(this).data('printcode'); // ★data-printcode に統一

    // RadioがあればUIにも反映、なければ hidden を更新
    setPrintCode(printCode);

    smoothScrollTo($('#EasyCal'), 800);
    return false;
  });

  //========================
  // 計算処理（本体）
  //========================
  window.EasyCalAction = function EasyCalAction(printCode, width, height) {
    // data属性から最大値を取得（デフォルト値: 幅1250mm、高さ5000mm）
    var $easyCal = $('#EasyCal');
    var maxWidth = parseInt($easyCal.attr('data-max-width')) || 1250;
    var maxHeight = parseInt($easyCal.attr('data-max-height')) || 5000;

    // 入力チェック
    if (!width || !height) {
      alert('寸法が入力されておりません。');
      markError(!width, !height);
      smoothScrollTo($('#SizeInputSpot'), 800, -100);
      return false;
    } else if (width < 100 || height < 100) {
      alert('最小製作サイズは100mm以上となります。');
      markError(width < 100, height < 100);
      smoothScrollTo($('#SizeInputSpot'), 800, -100);
      return false;
    } else if (width > maxWidth && height > maxWidth) {
      alert('最大製作幅は' + maxWidth + 'mmとなります。');
      if (width < height) markError(true, false);
      else if (height < width) markError(false, true);
      else markError(true, true);
      smoothScrollTo($('#SizeInputSpot'), 800, -100);
      return false;
    } else if (width > maxHeight || height > maxHeight) {
      alert('最大製作長さは' + maxHeight + 'mmとなります。');
      if (width < height) markError(false, true);
      if (height < width) markError(true, false);
      smoothScrollTo($('#SizeInputSpot'), 800, -100);
      return false;
    } else {
      $('input[name=width],input[name=height]').removeClass('BL-Red StatP').addClass('BL-SKY');
    }

    // ここから非同期差し替え（v1.1）
    var targetURL = '?calucation=1'
      + '&width=' + encodeURIComponent(width)
      + '&height=' + encodeURIComponent(height)
      + '&printCode=' + encodeURIComponent(printCode || '');
    var targetTags = ['main'];
    startReloadCotent();
    var dfd = reloadCotent(targetURL, targetTags, 1);
    dfd.done(function () {
      if (typeof thisPageReloadContent === 'function') thisPageReloadContent();
      smoothScrollTo($('#EasyCalResult'), 800);
    });
  };

  //========================
  // 価格の非同期読込
  //========================
  function loadPrintPrices() {
    $('.loadPrintPrice').each(function () {
      var $obj = $(this);
      var printCode = $obj.attr('data-print_code');
      var width = $obj.attr('data-width');
      var height = $obj.attr('data-height');
      var lamiOption = $obj.attr('data-lamiOption');
      var itemNum = $obj.attr('data-item_num');
      $.getJSON('/seisaku/print/load-print-price.html', {
        printCode: printCode,
        width: width,
        height: height,
        lamiOption: lamiOption,
        itemNum: itemNum
      }, function (data) {
        $obj.find('.showUnitPrice').text(data['totalNetPrice']);
        $obj.find('.showPrice').text(data['totalGrossPrice']);
        // セール中だけ「通常価格（訂正線）」を出す。
        // isOnSale は API 側で「値引きが実際に効いたか」まで見て立てている。
        // 旧APIレスポンス（isOnSale を返さない）でも undefined で素通りし、何も出ない。
        if (data['isOnSale']) {
          $obj.find('.showBeforeSalePrice').text(data['totalNetPriceBeforeSale']);
          // 三角バッジは価格ブロック側（$obj の外）にあるので、目印の printPriceBlock まで遡る。
          // 見つからない場合は $obj の中だけを対象にする（バッジ無しの古いHTMLでも壊れない）。
          var $block = $obj.closest('.printPriceBlock');
          if (!$block.length) { $block = $obj; }
          $block.find('.showSalePercent').text(data['saleDiscountPercent']);
          // 税抜の行はセール中だけ赤にする（FCPriceRed と FCDarkBlue が両方付くと
          // どちらも !important で読み込み順に左右されるため、紺は外してから赤を付ける）
          $block.find('.unitPriceLine').removeClass('FCDarkBlue').addClass('FCPriceRed');
          // 通常価格の行・セール期限の注記・三角バッジは、まとめて saleOnly で出す
          $block.find('.saleOnly').removeClass('Hidden');
        }
      });
    });
  }

  //========================
  // LIVE価格（選択肢カードの1枚単価を、今のサイズで即時表示）
  //========================
  // #EasyCal 内の .livePrice[data-livecode] を集めて load-live-prices で一括計算し、各要素に net を表示。
  // 未設定（サイズ未入力・価格不能）は '--' ＆ 親<p>を FCGray7、価格確定で FCGreen にトグルする。
  // 対象要素が無いページでは何もしない（汎用・無害）。
  function setLivePriceState($slot, isSet) {
    var $p = $slot.closest('p');
    if (isSet) { $p.removeClass('FCGray7').addClass('FCGreen'); }
    else { $p.removeClass('FCGreen').addClass('FCGray7'); }
  }
  function loadLivePrices() {
    var $root = $(SCOPE);
    if (!$root.length) return;
    var $slots = $root.find('.livePrice[data-livecode]');
    if (!$slots.length) return;
    var w = parseInt($root.find('input[name=width]').val(), 10);
    var h = parseInt($root.find('input[name=height]').val(), 10);
    // サイズ未入力・不正なら未設定表示（'--' ＆ 灰色）。
    if (!w || !h || w < 1 || h < 1) {
      $slots.each(function () { setLivePriceState($(this).text('--'), false); });
      return;
    }
    // 表示中の全コードをまとめて1回のAPIで取得（重複除去）。
    var codes = [];
    $slots.each(function () {
      var c = $(this).attr('data-livecode');
      if (c && codes.indexOf(c) < 0) codes.push(c);
    });
    $.getJSON('/seisaku/print/load-live-prices.html', { width: w, height: h, itemNum: 1, codes: codes })
      .done(function (res) {
        var prices = (res && res.prices) ? res.prices : {};
        $slots.each(function () {
          var $s = $(this), code = $s.attr('data-livecode');
          var net = (prices[code] && typeof prices[code].net === 'number') ? prices[code].net : null;
          if (net && net > 0) { setLivePriceState($s.text(net.toLocaleString()), true); }
          else { setLivePriceState($s.text('--'), false); }
        });
      });
  }
  var loadLivePricesDebounced = (function () {
    var t;
    return function () { clearTimeout(t); t = setTimeout(loadLivePrices, 400); };
  })();
  // サイズ変更（入力／寸法ピル）で LIVE価格を更新する。
  $(document).on('input change', SCOPE + ' input[name=width], ' + SCOPE + ' input[name=height]', loadLivePricesDebounced);
  $(document).on('click', SCOPE + ' a.addSize', function () { setTimeout(loadLivePrices, 0); });

  //========================
  // 再初期化フック
  //========================
  window.thisPageReloadContent = function thisPageReloadContent() {
    // remodal 再定義
    var remodalIds = [];
    $('main').find('.modalArea').each(function () {
      remodalIds.push($(this).attr('data-remodal-id'));
    });
    $.each(remodalIds, function (i, remodalId) {
      $('[data-remodal-id=' + remodalId + ']').remodal().destroy();
      $('[data-remodal-id=' + remodalId + ']').remodal();
    });

    // ラミタブ初期化
    $('div.tab-content').hide();
    $('div.tab-active').show();

    // 価格再ロード
    loadPrintPrices();
    loadLivePrices();

    // メディア選択状態の反映（Radioのみ）
    reflectMediaSelection();

    // ラジオアコーディオン等の再初期化（存在時）
    if (typeof window.RadioAccordionInit === 'function') {
      try { window.RadioAccordionInit(document); } catch (e) { console.warn('RadioAccordionInit error', e); }
    }

    // レイアウト系の再評価（ヘッダー固定/下部固定など）
    try {
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    } catch (e) { }
  };

  //========================
  // 小ユーティリティ（既存）
  //========================
  window.smoothScrollTo = window.smoothScrollTo || function($target, speed, offset){
    if (!$target || !$target.length) return;
    var adjust = Number(offset || 0);
    var position = $target.offset().top + adjust;
    $('html, body').animate({ scrollTop: position }, Number(speed || 600), 'swing');
  };

  window.markError = window.markError || function(wErr, hErr){
    var $w = $('input[name=width]');
    var $h = $('input[name=height]');
    $w.removeClass('BL-SKY');
    $h.removeClass('BL-SKY');
    if (wErr) $w.addClass('BL-Red StatP'); else $w.removeClass('BL-Red StatP');
    if (hErr) $h.addClass('BL-Red StatP'); else $h.removeClass('BL-Red StatP');
  };

  // 初回ロード時の価格表示
  $(function(){ loadPrintPrices(); loadLivePrices(); });

})(jQuery);
